export default __webpack_public_path__ + "static/media/announcement-grey.9f1bf02e.svg";